import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Header from '../../../components/Header';

export default () => (
  <Header>
    <NavLink exact to="/" activeClassName="active">
      PRODUCTION
    </NavLink>
    <NavLink to="/contact" activeClassName="active">
      CONTACT
    </NavLink>
  </Header>
);
